import { message, Switch } from 'antd'
import moment from 'moment'
import copyToExcel from 'copy-to-excel';

export const evaluateMoment = (attribute) => {
  if (attribute instanceof Weaver.Attribute) {
    return moment(attribute.value).format('DD-MM-YYYY HH:mm')
  } else if (moment.isMoment(attribute.value)) {
    return moment(attribute.value).format('DD-MM-YYYY HH:mm')
  } else if (typeof attribute.value === 'string' || attribute.value instanceof String) {
    return moment(attribute.value).format('DD-MM-YYYY HH:mm')
  } else {
    return "[ could not parse date ]"
  }
}

export const sorter = (a, b) => {
  if (moment(a, 'DD-MM-YYYY hh:mm', true).isValid()) {
    return moment(a, 'DD-MM-YYYY hh:mm') - moment(b, 'DD-MM-YYYY hh:mm');
  } else if (typeof a === 'string' && typeof b === 'string') {
    return a.localeCompare(b);
  } else {
    return a - b;
  }
}

export const copyToClipboard = (tableData) => {
  const cloneTable = _.cloneDeep(tableData);
  const parsedTableData = cloneTable.map((item) => {
    delete item.key
    return item
  })
  const headers = Object.keys(parsedTableData[0] || {})

  return () => (
      <a
        target="_blank"
        onClick={async () => {
          const excel = copyToExcel(parsedTableData, headers);
          await navigator.clipboard.writeText(excel)
          message.success('Gekopieerd')
        }}
      >Kopieer data naar klembord</a>
  )
}

export const formatDuration  = (diff) => {
  const y = diff._data.years;
  const months = diff._data.months;
  const d = diff._data.days;
  const h = String(diff._data.hours).padStart(2, '0');
  const m = String(diff._data.minutes).padStart(2, '0');
  const s = String(diff._data.seconds).padStart(2, '0');

  var text = '';
  if (y > 0) {
    text += `${y} jaar `
  }
  if (months > 0) {
    if (months === 1) {
      text += '1 maand'
    } else {
      text += `${months} maanden `
    }
  }
  if (d > 0) {
    if (d === 1) {
      text += '1 dag'
    } else {
      text += `${d} dagen `
    }
  }
  return `${text} ${h}:${m}:${s}`
}

export const HideClosed = ({ setHideClosed }) => {
  return (
    <Switch
      checkedChildren={"Verberg Afgesloten"}
      unCheckedChildren={"Verberg Afgesloten"}
      defaultChecked={true}
      onChange={setHideClosed}
    />
  )
}
